<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>{{'SAMPLE.MESSAGE' | translate}}</h2>

</div>
